import PropTypes from 'prop-types';
import { DEPRECATED_PROP_MESSAGES } from '../../constants/messages.js';
import { useControllableValue } from '../../hooks/use-controllable-value.js';
import { composeEventHandlersUtil } from '../../utilities/compose-event-handlers.util.js';
import { createComponent } from '../core/create-component.js';
import { deprecatedProp } from '../core/deprecated-prop.js';
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpreadProps(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
const ToggleSwitchSize = {
  Standard: 'standard',
  Super: 'super',
  Mini: 'mini'
};
const propTypes = {
  sizeVariant: deprecatedProp(PropTypes.oneOf([ToggleSwitchSize.Standard, ToggleSwitchSize.Super, ToggleSwitchSize.Mini]), DEPRECATED_PROP_MESSAGES.size),
  size: PropTypes.oneOf([ToggleSwitchSize.Standard, ToggleSwitchSize.Super, ToggleSwitchSize.Mini]),
  hideText: PropTypes.bool,
  activated: PropTypes.bool,
  onRequestActivatedChange: PropTypes.func,
  defaultActivated: PropTypes.bool
};
const ToggleSwitch = createComponent({
  displayName: 'ToggleSwitch',
  root: 'button',
  propTypes,
  propConfig: {
    derivedProps(props) {
      const {
        defaultActivated = false,
        activated: controlledActivated,
        onRequestActivatedChange: controlledOnRequestActivatedChange
      } = props;
      const [activated, onRequestActivatedChange] = useControllableValue({
        value: controlledActivated,
        onChange: controlledOnRequestActivatedChange || undefined,
        defaultValue: defaultActivated,
        defaultOnChange: function (setActivated) {
          for (var _len = arguments.length, onChangeArgs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
            onChangeArgs[_key - 1] = arguments[_key];
          }
          const [val] = onChangeArgs;
          setActivated(val);
        }
      });
      return {
        activated: !!activated,
        onRequestActivatedChange
      };
    },
    processProps(props, derivedProps) {
      const {
        activated,
        onRequestActivatedChange
      } = derivedProps;
      return _objectSpreadProps(_objectSpread({}, props), {
        role: 'switch',
        'aria-checked': activated,
        onClick: composeEventHandlersUtil(props.onClick, event => {
          onRequestActivatedChange(!activated, event);
        })
      });
    },
    classNames(props) {
      const classNameSet = new Set(['swan-vanilla-ignore', 'swan-toggle-switch']);
      const {
        hideText,
        sizeVariant = ToggleSwitchSize.Standard,
        size = sizeVariant
      } = props;
      if (size === ToggleSwitchSize.Mini) classNameSet.add("swan-toggle-switch-".concat(size));
      if (size === ToggleSwitchSize.Super) classNameSet.add("swan-toggle-switch-".concat(size));
      if (hideText) classNameSet.add('swan-toggle-switch-hide-text');
      return classNameSet;
    }
  }
});
export { ToggleSwitch, ToggleSwitchSize };